export default __webpack_public_path__ + "0a396b250daf9c335c56669948c975df.svg";